// Ð§ÑÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ ÑÐ¶Ðµ Ð¿ÑÐ¾ÑÑÐ»: ÑÑÑ Ð¸ Ð¿ÑÐ½ÐºÑÑ ÑÐµÐº-Ð»Ð¸ÑÑÐ°.
//
// Ð¥ÑÐ°Ð½Ð¸ÑÑÑ Ð² Ð¿ÑÐ¾ÑÐ¸Ð»Ðµ Ð½Ð° ÑÐµÑÐ²ÐµÑÐµ â Ð¸Ð½Ð°ÑÐµ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ, Ð¿ÐµÑÐµÑÐµÐ²ÑÐ¸Ð¹ Ð·Ð° ÑÐ¾ÑÐµÐ´Ð½Ð¸Ð¹
// ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑ, Ð¿Ð¾Ð»ÑÑÐ°Ð» Ð±Ñ ÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾. Ð Ð±ÑÐ°ÑÐ·ÐµÑÐµ Ð´ÐµÑÐ¶Ð¸Ð¼ ÐºÐ¾Ð¿Ð¸Ñ: Ð¾Ð½Ð° Ð¾ÑÐ²ÐµÑÐ°ÐµÑ
// Ð¼Ð³Ð½Ð¾Ð²ÐµÐ½Ð½Ð¾, Ð¿Ð¾ÐºÐ° Ð¸Ð´ÑÑ Ð·Ð°Ð¿ÑÐ¾Ñ, Ð¸ Ð²ÑÑÑÑÐ°ÐµÑ, ÐµÑÐ»Ð¸ ÑÐµÑÐ²ÐµÑ Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½.
//
// ÐÐ±ÑÑÐµÐ½Ð¸Ðµ â Ð½Ðµ ÑÐ° Ð²ÐµÑÑ, Ð¸Ð·-Ð·Ð° ÐºÐ¾ÑÐ¾ÑÐ¾Ð¹ ÑÑÐ¾Ð¸Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ Ð¾ÑÐ¸Ð±ÐºÑ: Ð»ÑÐ±Ð¾Ð¹ ÑÐ±Ð¾Ð¹
// Ð·Ð°Ð¿ÑÐ¾ÑÐ° Ð·Ð´ÐµÑÑ Ð³Ð°ÑÐ¸ÑÑÑ, Ð¸ ÑÐµÐ»Ð¾Ð²ÐµÐº Ð¿ÑÐ¾ÑÑÐ¾ ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð´Ð°Ð»ÑÑÐµ.

import getOnboarding from '../../api/onboarding/getOnboarding';
import saveOnboarding from '../../api/onboarding/saveOnboarding';
import resetOnboardingOnServer from '../../api/onboarding/resetOnboarding';

import { CHECKLIST_ITEMS } from './onboardingSteps';

const PREFIX = 'onboarding';

const EMPTY_STATE = { tourSeen: false, checklist: [], checklistHidden: false };

// ÐÐ¾Ð¿Ð¸Ñ Ð² Ð±ÑÐ°ÑÐ·ÐµÑÐµ Ð»ÐµÐ¶Ð¸Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾ Ð½Ð° ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾: Ð·Ð° Ð¾Ð´Ð½Ð¸Ð¼ ÐºÐ¾Ð¼Ð¿ÑÑÑÐµÑÐ¾Ð¼ Ð² ÑÐ°Ð»Ð¾Ð½Ðµ
// ÑÐ°Ð±Ð¾ÑÐ°ÐµÑ Ð²ÑÑ ÑÐ¼ÐµÐ½Ð°.
const keyFor = (userId, name) => `${PREFIX}:${userId || 'anonymous'}:${name}`;

// localStorage Ð½ÐµÐ´Ð¾ÑÑÑÐ¿ÐµÐ½ Ð² Ð¿ÑÐ¸Ð²Ð°ÑÐ½Ð¾Ð¼ Ð¾ÐºÐ½Ðµ Ð¸ Ð¿ÑÐ¸ Ð·Ð°Ð¿ÑÐµÑÐµ Ð½Ð° ÑÐ°Ð¹Ñ â ÑÐ¾Ð³Ð´Ð°
// Ð¿ÑÐ¾ÑÑÐ¾ Ð²ÐµÐ´ÑÐ¼ ÑÐµÐ±Ñ ÐºÐ°Ðº Â«Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¾Â», Ð° Ð½Ðµ ÑÐ¾Ð½ÑÐµÐ¼ ÑÑÑÐ°Ð½Ð¸ÑÑ.
const read = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

const remove = (key) => {
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

const cleanChecklist = (items) => {
  if (!Array.isArray(items)) return [];
  return CHECKLIST_ITEMS.filter((item) => items.includes(item));
};

export const readLocalState = (userId) => {
  const raw = read(keyFor(userId, 'state'));
  if (!raw) return { ...EMPTY_STATE };

  try {
    const parsed = JSON.parse(raw);
    return {
      tourSeen: !!parsed?.tourSeen,
      checklist: cleanChecklist(parsed?.checklist),
      checklistHidden: !!parsed?.checklistHidden,
    };
  } catch (e) {
    // ÐÑÐ¸ÑÑÐ» Ð¼ÑÑÐ¾Ñ Ð¸Ð»Ð¸ ÐºÐ»ÑÑ Ð¸Ð· Ð¿ÑÐ¾ÑÐ»Ð¾Ð¹ Ð²ÐµÑÑÐ¸Ð¸ â ÑÑÐ¸ÑÐ°ÐµÐ¼, ÑÑÐ¾ Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¿ÑÐ¾Ð¹Ð´ÐµÐ½Ð¾.
    return { ...EMPTY_STATE };
  }
};

export const writeLocalState = (userId, state) => write(keyFor(userId, 'state'), JSON.stringify(state));

export const clearLocalState = (userId) => remove(keyFor(userId, 'state'));

// Ð¡Ð¾ÑÑÐ¾ÑÐ½Ð¸Ðµ Ð¿ÑÐ¸ Ð²ÑÐ¾Ð´Ðµ. Ð¡ÐµÑÐ²ÐµÑ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð» â Ð±ÐµÑÑÐ¼ ÐºÐ¾Ð¿Ð¸Ñ Ð¸Ð· Ð±ÑÐ°ÑÐ·ÐµÑÐ°, ÑÑÐ¾Ð±Ñ Ð½Ðµ
// Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ ÑÑÑ ÑÐµÐ»Ð¾Ð²ÐµÐºÑ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÐµÐ³Ð¾ ÑÐ¶Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ð».
export const loadOnboardingState = async (userId) => {
  try {
    const { data } = await getOnboarding();

    const state = {
      tourSeen: !!data?.tourSeen,
      checklist: cleanChecklist(data?.checklist),
      checklistHidden: !!data?.checklistHidden,
    };

    writeLocalState(userId, state);
    return state;
  } catch (e) {
    return readLocalState(userId);
  }
};

// Ð¡Ð¾ÑÑÐ°Ð½ÑÐµÐ¼ ÑÑÐ°Ð·Ñ Ð¸ Ð² Ð±ÑÐ°ÑÐ·ÐµÑ, Ð¸ Ð½Ð° ÑÐµÑÐ²ÐµÑ: Ð¾ÑÐ²ÐµÑÐ° Ð¶Ð´Ð°ÑÑ Ð½ÐµÐºÐ¾Ð¼Ñ, ÑÐºÑÐ°Ð½ ÑÐ¶Ðµ
// Ð¿ÐµÑÐµÑÐ¸ÑÐ¾Ð²Ð°Ð»ÑÑ.
export const persistOnboardingState = async (userId, state) => {
  writeLocalState(userId, state);

  try {
    await saveOnboarding(state);
    return true;
  } catch (e) {
    return false;
  }
};

export const resetOnboardingState = async (userId) => {
  clearLocalState(userId);

  try {
    await resetOnboardingOnServer();
    return true;
  } catch (e) {
    return false;
  }
};
